import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locales from '../assets/lang'

export function installVue2I18n() {
    Vue.use(VueI18n)
}

export function createVue2I18n() {
    return new VueI18n({
        locale: localStorage.lang || 'pt',
        messages: locales
    })
}
